module.exports = __webpack_public_path__ + "img/identification.7e5be9ad.svg";